<div class="filter-container">
  <div class="filter-header">
    <h3 class="filter-title">Filtrer efter kategori</h3>
  </div>
  <div class="filter-options">
    @for (category of categories; track category) {
    <button
      class="filter-button"
      [class.active]="selectedCategories.includes(category.value)"
      (click)="toggleCategory(category.value)"
    >
      {{ category.label }}
    </button>
    } @if (hasSelectedCategories()) {
    <button class="clear-button" (click)="clearFilters()">Ryd filtre</button>
    }
  </div>
</div>
